import React, { useState } from "react";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Link } from "react-router-dom";
import Storage from "../../utils/storage";
import { userLogin } from "../../redux/Actions/LoginActions";
import Loader from "../../components/Loader/Loader";
import Button from "../../components/Button/Button";
import FormInput2 from "../../components/FormInput/FormInput2";
import { LoginSchema } from "../../utils/validation";
import { useHistory } from "react-router-dom";
import { PropTypes } from 'prop-types';

const Login = ({ login, isLoading }) => {
  const history = useHistory();
  const [keep, setKeep] = useState(false);

  const [state, setState] = useState({
    hide: true,
  });

  const handleClick = () => {
    setState({
      ...state,
      hide: !state.hide,
    });
  };

  return (
    <div className="form">
      <div className="form-wrap">
        <div className="form-text">
          <div className="form-text-group">
            <h1 className="form-text-heading">Welcome,</h1>
            <p className="form-text-subheading">
              Login to your <span id="nibss">NIBSS</span> account.
            </p>
          </div>
        </div>

        <Formik
          initialValues={{ email: "", password: "" }}
          onSubmit={(values) => {
            const loginvalues = {
              email: values.email.trim(),
              password: values.password,
            };
            login({ val: loginvalues, keepState: keep }, history);
            Storage.set("keep", keep)
            Storage.set("user-email", values.email.trim())
          }}
          validationSchema={LoginSchema}
        >
          {({ handleSubmit, isValid, dirty }) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className="form-input-wrap">
                  <div className="form-input">
                    <Field
                      name="email"
                      label="Email Address"
                      placeholder="Enter email address"
                      component={FormInput2}
                    />
                  </div>
                  <div className="form-input-password">
                    <span id="show" onClick={handleClick}>
                      {state.hide ? "SHOW" : "HIDE"}
                    </span>
                    <Field
                      name="password"
                      label="Password"
                      placeholder="Enter Password"
                      type={state.hide ? "password" : "text"}
                      component={FormInput2}
                    />
                  </div>

                  <div className="form-input-button">
                    <Button
                      width="100%"
                      height="45px"
                      word={"SIGN IN"}
                      disabled={isLoading || !(isValid && dirty)}
                      img={isLoading ? <Loader  /> : ""}
                    />
                  </div>
                  <div className="form-bottom">
                    <span id="check">
                      <input
                        className="check-button"
                        type="checkbox"
                        onChange={() => setKeep(!keep)}
                      />
                      <p>Keep me logged in</p>
                    </span>
                    <span id="forgot">
                      <Link
                        to="/reset-password"
                        className="bottom-forgot-password"
                      >
                        Forgot Password?
                      </Link>
                    </span>
                  </div>

                  <div className="form-bottom-signup">
                    <p>
                      Sign Up{" "}
                      <Link
                        to="/sign-up"
                        style={{
                          color: "#22a4ef",
                          textDecoration: "none",
                        }}
                      >
                        here,
                      </Link>{" "}
                     if you want to create an account
                    </p>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  login: (user, history) => dispatch(userLogin(user, history)),
});

const mapStateToProps = (state) => ({
  isLoading: state.auth.isLoading,
  currentUser: state.auth.currentUser,
  data: state.auth.data,
  isAuthenticated: state.auth.isAuthenticated,
});

Login.propTypes = {
  currentUser: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isLoading: PropTypes.bool,
  login: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
